import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 7l5 5l-5 5","key":"svg-0"}],["path",{"d":"M12 19l7 0","key":"svg-1"}]]

const IconTerminal = createReactComponent('outline', 'terminal', 'Terminal', __iconNode);

export default IconTerminal;